import { ActionMenu } from 'components/ActionStyles/ActionStyles'
import RightArrow from 'components/icons/RightArrow'
import React from 'react'
import { COLORS } from 'theme'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import {
  CandCount,
  CardSectionFlex,
  CardText,
  CardsDiv,
  CardsFlex,
  CardsRowFlex,
  CardsValue,
  RoleFlex,
  RoleNumber,
  RoleTitle,
} from '../../Style/style'

export const roleMenu = (onRoleChange, roleMenu = []) => (
  <ActionMenu
    width="335px"
    items={
      Array.isArray(roleMenu)
        ? roleMenu?.map((role, index) => {
            return {
              key: index,
              label: (
                <RoleFlex
                  row
                  spaceBetween
                  centerVertically
                  onClick={() => onRoleChange(role?.roleId)}
                >
                  <RoleFlex column>
                    <RoleNumber>Role {getZeroBeforeInt(index + 1)}</RoleNumber>
                    <RoleTitle>{role?.roleName}</RoleTitle>
                  </RoleFlex>
                  <CandCount>
                    {getZeroBeforeInt(role?.candidateCount)}
                  </CandCount>{' '}
                </RoleFlex>
              ),
            }
          })
        : Object.keys(roleMenu)
    }
  />
)

const DriveRoleMetrics = ({
  rolesMetrics,
  selectedRound,
  setSelectedRound,
  setSearchParams,
  setCurrentPage,
  setSelectedCandidateId,
  setSelectedCandidate,
  setCurrentTab,
  setStatus,
  setFilterStatus,
  setSelectionType,
}) => {
  const onClickRound = round => {
    setCurrentPage(0)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setCurrentTab('SCHEDULED,SHORTLISTED')
    setStatus('SCHEDULED,SHORTLISTED')
    setFilterStatus('SCHEDULED,SHORTLISTED')
    setSelectionType('active')
    setSelectedRound(round)
    setSearchParams({ stage: round })
  }

  return (
    <CardsRowFlex row>
      <CardsDiv>
        <CardsFlex
          column
          onClick={() => onClickRound('all_candidates')}
          isSelected={selectedRound === 'all_candidates'}
        >
          <CardText>All Candidates</CardText>
          <CardsValue>
            {getZeroBeforeInt(rolesMetrics[0]?.candidateCount)}
          </CardsValue>
        </CardsFlex>
      </CardsDiv>
      {rolesMetrics[0]?.rounds?.map((round, index) => (
        <CardSectionFlex key={index + round?.roundName} centerVertically>
          <CardsFlex
            column
            onClick={() => onClickRound(round?.roundName)}
            isSelected={selectedRound === round?.roundName}
          >
            <CardText>{round?.roundName}</CardText>
            <CardsValue>{getZeroBeforeInt(round?.count)}</CardsValue>
          </CardsFlex>
          {rolesMetrics[0]?.rounds?.length - 1 !== index && (
            <RightArrow color={COLORS.GREY_T_80} />
          )}
        </CardSectionFlex>
      ))}
    </CardsRowFlex>
  )
}

export default DriveRoleMetrics
